/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { ActivityToType } from "../api/types/types";
import { CreateOrEditFormValues } from "../components/CreateOrUpdateActivityModal/CreateOrUpdateActivityModal";

export const DEFAULT_ACTIVITY_DURATION = 30;

export const mapBaseActivityInputsToPayload = (
  currentFarmerAccountNumber: string,
  values: CreateOrEditFormValues
) => ({
  accountNumber: currentFarmerAccountNumber,
  activityType: Number(values.activityType),
  subject: values.subject,
  description: values.description,
  scheduleDate: values.scheduleDate?.toISOString() ?? "",
  dueDate: values.scheduleDate?.toISOString() ?? "",
  status: values.activityStatus,
  to: values.contactId,
  toType: ActivityToType.Contact,
  contactId: values.contactId,
});
